import { useNavigate } from '@tanstack/react-router';
import { useAuth } from '../contexts/AuthContext';

export function useRequireAuth() {
  const { isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();

  if (!isLoading && !isAuthenticated) {
    navigate({ to: '/auth' });
  }

  return { isLoading, isAuthenticated };
}
